<template>
    <Widget title="Activity Calendar" :area="this.$props.area">
        <template v-if="hasData">
            <WidgetFilter :sections="{filter:'filter'}" slot="extras">
                <div slot="filter">
                    <Label text="Show:">
                        <el-radio v-model="show" label="activity">Activity</el-radio>
                        <el-radio v-model="show" label="karma">Karma</el-radio>
                    </Label>
                </div>
            </WidgetFilter>
            <div class="controls">
                <div class="year_control">
                    <!--mousedown.prevent stops the fast clicking on the buttons from selecting stuff-->
                    <span class="pointer" @mousedown.prevent="" @click.prevent="year_offset--"><</span>
                    {{this.year}}
                    <span class="pointer" @mousedown.prevent="" @click.prevent="year_offset++">></span>
                </div>
                <div class="type_control">
                    <el-radio v-model="type" label="t1">Comments</el-radio>
                    <el-radio v-model="type" label="t3">Submissions</el-radio>
                    <el-radio v-model="type" label="t">Any</el-radio>
                </div>
            </div>

            <calendar-heatmap :range-color="colors" :tooltipUnit="show==='karma'?'karma':'posts'" :values="data"
                              :end-date="end"
                              @day-click="click"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import * as moment from "moment";
    import {mapGetters} from "vuex";
    import Label from "../Label";
    import WidgetFilter from "../WidgetFilter";

    export default {
        props: {area: String, dialog: Function},
        components: {Widget, WidgetFilter, Label},
        data() {
            return {type: 't1', year_offset: 0, show: 'activity'}
        },
        computed: {
            ...mapGetters(['allPosts']),
            hasData() {
                return this.allPosts.length > 0;
            },
            colors() {
                return this.show === 'karma' ?
                    ['rgba(0,0,0,0.21)', 'rgba(0,204,136,0.20)', 'rgba(0,204,1360,0.40)', 'rgba(0,204,136,0.60)', 'rgba(0,204,136,0.80)', 'rgba(0,204,136,1)']
                    :
                    ['rgba(0,0,0,0.21)', 'rgba(255,204,0,0.20)', 'rgba(255,204,0,0.40)', 'rgba(255,204,0,0.60)', 'rgba(255,204,0,0.80)', 'rgba(255,204,0,1)'];
            },
            year() {
                return moment().add(this.year_offset, 'years').year()
            },
            end() {
                return moment().add(this.year_offset, 'years').format('YYYY-MM-DD')
            },
            data() {

                let data = this.allPosts.filter(d => d.kind.indexOf(this.type) === 0)
                    .reduce((a, c) => {
                        let date = moment.utc(c.data.created_utc * 1000);
                        let key = date.format('YYYY-MM-DD');
                        // let key = date.unix();
                        // let key = c.data.created_utc;
                        if (a[key])
                            a[key].push(c);
                        else
                            a[key] = [c];

                        return a;
                    }, {});

                // todo count either number of activity or total karma
                let res = Object.entries(data).map(([k, v]) => {
                    let val = v.length;
                    if (this.show === 'karma')
                        val = v.reduce((a, c) => a += c.data.score, 0)
                    return {
                        date: moment.utc(k).toDate(),
                        count: val,
                        posts: v
                    }
                });

                return res;
                // return [{date:moment.utc().,count:10}]
            }
        },
        methods: {
            click({date, count, colorIndex}) {
                date = moment(date).format('YYYY-MM-DD')
                let data = this.data.filter(d => moment(d.date).format('YYYY-MM-DD') === date)
                if (data.length > 0)
                    this.dialog(date + ' Posts', data[0].posts)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pointer {
        color: #fc0;
        cursor: pointer;
    }

    .controls {
        display: grid;
        grid-template-columns: auto 1fr auto;

        .year_control {
            span {
                margin: 0 1em;
            }
        }

        .type_control {
            grid-column: 3;
            margin-right: 1em;
        }
    }
</style>
<style>
    .cal-heatmap-container {
        margin: auto;
        text-shadow: none;
    }

    .vch__legend__wrapper {
        display: none;
    }
</style>
